module.exports = __webpack_public_path__ + "img/icon_map_1_yj.56a1b008.png";